var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#00C8C8"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1CADB5"
    },
    d: "M295.437,508.976C398.259,493.077,480.856,415.99,504.89,316.09L403.168,214.369l-13.698,9.426 l-80.84-80.84L119.555,333.094L295.437,508.976z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFD400"
    },
    points: "253.09,87.414 119.555,87.414 119.555,333.094 308.631,333.094 308.631,142.955 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFB000"
    },
    points: "308.631,142.955 253.09,87.414 207.952,87.414 207.952,333.094 308.631,333.094 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF432E"
    },
    points: "253.09,142.955 308.631,142.955 253.09,87.414 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "347.627,158.828 214.093,158.828 214.093,404.508 403.168,404.508 403.168,214.369 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F2F6FC"
    },
    points: "403.168,214.369 347.627,158.828 307.952,158.828 307.952,404.508 403.168,404.508 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#DCE1EB"
    },
    points: "347.627,214.369 403.168,214.369 347.627,158.828  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.5,
    y: 240.37,
    style: {
      fill: "#DCE1EB"
    },
    width: 138.26,
    height: 12.408
  })), /*#__PURE__*/React.createElement("rect", {
    x: 307.95,
    y: 240.37,
    style: {
      fill: "#CDD2E1"
    },
    width: 69.809,
    height: 12.408
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.5,
    y: 269.61,
    style: {
      fill: "#DCE1EB"
    },
    width: 138.26,
    height: 12.408
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.95,
    y: 269.61,
    style: {
      fill: "#CDD2E1"
    },
    width: 69.809,
    height: 12.408
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.5,
    y: 298.86,
    style: {
      fill: "#DCE1EB"
    },
    width: 138.26,
    height: 12.408
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.95,
    y: 298.86,
    style: {
      fill: "#CDD2E1"
    },
    width: 69.809,
    height: 12.408
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.5,
    y: 328.11,
    style: {
      fill: "#DCE1EB"
    },
    width: 138.26,
    height: 12.408
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.95,
    y: 328.11,
    style: {
      fill: "#CDD2E1"
    },
    width: 69.809,
    height: 12.408
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.1086fa185f1e689d43793aa9aeb90f2b.svg";
export { ForwardRef as ReactComponent };